import { render, staticRenderFns } from "./_base-search-selector.vue?vue&type=template&id=be435690&scoped=true&"
import script from "./_base-search-selector.vue?vue&type=script&lang=js&"
export * from "./_base-search-selector.vue?vue&type=script&lang=js&"
import style0 from "./_base-search-selector.vue?vue&type=style&index=0&id=be435690&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be435690",
  null
  
)

export default component.exports